module.exports = __webpack_public_path__ + "img/publish-0-pc.81519e54.png";